import React, { useState } from 'react'
import { EnterEmail } from '@/components/auth/enter-email'
import { EnterOtp } from '@/components/auth/enter-otp'
import { useSearchParams, useNavigate, Link } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import * as env from '@/env'
import { useSessionContext } from '@/state/session-context'

function Login() {
	const [currentStep, setCurrentStep] = useState(1)
	const [email, setEmail] = useState('')
	const [otpChallengeId, setOtpChallengeId] = useState('')
	const [searchParams] = useSearchParams()
	const returnTo = searchParams.get('returnTo') || '/chat'
	const navigate = useNavigate()
	const { refreshSession } = useSessionContext()

	// if (env.isProduction) {
	// 	return <div>Nothing to see here, please disperse.</div>
	// }

	const steps = [
		{ number: 1, title: 'Enter your email address' },
		{ number: 2, title: 'Enter email verification code' }
	]

	const renderStep = () => {
		switch (currentStep) {
			case 1:
				return <EnterEmail 
					mode="login"
					email={email} 
					setEmail={setEmail} 
					onContinue={() => setCurrentStep(2)}
					setOtpChallengeId={setOtpChallengeId}
				/>
			case 2:
				return <EnterOtp
					mode="login"
					email={email}
					otpChallengeId={otpChallengeId}
					onContinue={async () => {
						//	the verify-otp response sets the auth cookie, but useSession's
						//	cached `session` is still null from the initial mount when no
						//	cookie was present. refresh before navigating so guarded routes
						//	see the authenticated session and don't bounce back to landing.
						await refreshSession()
						navigate(returnTo)
					}}
					onBack={() => {
						setOtpChallengeId('')
						setCurrentStep(1)
					}}
				/>
			default:
				return null
		}
	}
	
	return (
		<div className="h-screen w-full flex flex-col bg-white">
			{/* <DevModeBanner /> */}
			<div className="container mx-auto p-4 max-w-md min-h-screen flex flex-col">
				<div className="flex-grow flex flex-col md:flex-row gap-4">
					<section className="flex-1 rounded-lg p-2">
						<h2 className="text-2xl font-bold mb-4">Login</h2>
						<div className="space-y-4">
							<div className="text-sm text-gray-500 flex justify-center">
								Don't have an account yet?
								<Link to="/#signup" className="text-rose-500 hover:text-rose-700 ml-2">
									Sign up here
								</Link>
							</div>
							
							{steps.map((step) => (
								<div
									key={step.number}
									className={`p-4 border rounded-md ${
										currentStep === step.number 
											? 'border-rose-600 shadow-md' 
											: 'border-gray-200'
									}`}
								>
									<h3 className="font-semibold mb-4">
										{step.number}. {step.title}
									</h3>
									{currentStep === step.number && (
										<div className="mt-6">
											{renderStep()}
										</div>
									)}
								</div>
							))}
						</div>
					</section>
				</div>
			</div>
			<Toaster />
		</div>
	)
}

export default Login 